<template>
 <div>
   <v-alert
      v-if="!loading && reviewsPackage.type == 'trial'"
      type="info"
      icon="timelapse"
      class="py-0 mb-4"
      mb-4
      prominent
      text
      dense
      >
      <v-row align="center">
        <v-col class="grow"><strong>Proefperiode</strong> van Reviews  is actief voor {{ activeCompData.name }}. </v-col>
        <v-col class="shrink">
          <v-btn
            color="info"
            outlined
            >
             Nog {{ reviewsPackage.days }} <span style="color: #2196f3" v-if="reviewsPackage.days == 1" >dag</span><span style="color: #2196f3" v-else>dagen</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-container v-if="!loading && companies.length > 1 && !demoMode" grid-list-md class="pa-0 pt-2" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12>
          <v-select
            v-if="!loading && companies.length > 1 && showOverview"
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"     
            item-text="name"
            item-value="id"
            hide-details
            v-on:input="loadJourneys()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            dense
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>

          <div class="header-select-button" v-if="!showOverview">
            <v-btn small fab dark depressed :color="companySecondaryColor"  @click="backToOverview()">
              <v-icon large darken>chevron_left</v-icon>
            </v-btn>
            <span  v-for="company in companies" :key="company.id">
              <span class="journey-header-comp" v-if="company.id == activeComp">{{ company.name }}</span>
            </span>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="loading || journeyLoading" class="blackbox-loader"></div>

    <v-card class="mt-4" outlined v-if="showOverview == true && loading == false">
      <v-card-title>
        <h4>Customer Journeys van {{ activeCompData.name }}</h4>
        <v-spacer></v-spacer>
        <v-btn v-if="(userPermissions.journeyEditJourney == true && journeys.length > 0) || (userRole == 'admin' && journeys.length > 0) || (userRole == 'superadmin' && journeys.length > 0)" fab dark :color="companyPrimaryColor" @click="newJourneyDialog = true, getJourneyComp()">
          <v-icon darken>add</v-icon>
        </v-btn>
      </v-card-title>

      <div v-if="this.journeys.length > 0">
        <v-data-table
          :headers="headerJourneys"
          :items="journeys"
          v-model="selectedCustomerJourney"
          :itemsPerPage.sync="journeyPages"
          hide-default-footer
          >
          <template v-slot:item="{item}">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.description }}</td>
              <td> 
                <span v-for="type in journeyTypes" :key="type.id">
                  <span v-if="type.id == item.type"> {{ type.name }} </span>
                </span>
              </td>
              <td >
                <span v-for="(journey, key) in activeCompJourneys" :key="key"> 
                  <div v-if="item.id == key">
                    <v-switch
                    class="ma-0 pa-0"
                      v-if="item.id == key && journey == true"
                      input-value="true"
                      :color="companyPrimaryColor"
                      hide-details
                      @click.stop="changeJourneyStatus(item.id, 'true')"
                    ></v-switch>
                    <v-switch
                      class="ma-0 pa-0"
                      v-else-if="item.id  == key && journey == false"
                      input-value=""
                      :color="companyPrimaryColor"
                      hide-details
                      @click.stop="changeJourneyStatus(item.id, 'false')"
                    ></v-switch>
                  </div>
                </span>
              </td>
              <td>
                <v-btn v-if="(item.type == 'business' && userPermissions.journeyEditJourney == true) || userRole == 'superadmin'" style="float: right;" icon class="mx-0" @click="editJourney(item)">
                  <v-icon small :style="{color: $vuetify.theme.themes[theme].text}">edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn style="float: right;" icon class="mx-0" @click="selectJourney(item)">
                  <v-icon large :style="{color: $vuetify.theme.themes[theme].text}">chevron_right</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>

      <div class="no-content text-center"  v-else> 
        <p>Nog geen Journey toegevoegd</p>
        <v-btn dark :color="companyPrimaryColor" v-if="(userPermissions.journeyEditJourney == true && journeys.length == 0) || (userRole == 'admin' && journeys.length == 0) || (userRole == 'superadmin' && journeys.length == 0)" @click.stop="newJourneyDialog = true">Journey toevoegen</v-btn>
      </div>
    </v-card>   

    <div v-show="activeJourney && showOverview == false && journeyLoading == false">
      <v-card class="my-4" outlined v-for="journey in selectedJourney" :key="journey.name">
        <v-card-title>
          <div>
          <h2>{{ journey.name }}
            <span class="journey-header-type" v-if="activeJourney.type == 'global'" >
              <span>
                <v-icon>public</v-icon>
              </span>
              Algemene Journey
            </span>
            <span class="journey-header-type" v-if="activeJourney.type == 'business'" >
              <span>
                <v-icon>business</v-icon>
              </span>
              Individuele Journey
            </span>
          </h2>
          <p class="ma-0" style="font-size: 14px">{{ journey.description }}</p>
          </div>
          <v-spacer></v-spacer>
          <v-btn v-if="(activeJourney.type == 'business' && userPermissions.journeyEditQuestions == true) || (userRole == 'admin' || activeJourney.type == 'business' && userRole == 'admin') || (activeJourney.type == 'global' && userRole == 'admin')  || userRole == 'superadmin'" outlined :color="companySecondaryColor" @click.stop="newStageDialog = true, setRandomStageColor()">Stage toevoegen</v-btn>
        </v-card-title>
        <v-card-text>
          <div id="stages" class="stages-wrapper">
            <div class="stage-item" v-for="(stage, index) in stages" :data-index="index" :key="stage.order" v-bind:class="{ last : $last(stage,stages), first : $first(stage,stages) }">
              <div class="header" v-bind:style="{ background: stage.color }">
                <div class="handle" v-if="(activeJourney.type == 'business' && userPermissions.journeyEditQuestions == true) || (userRole == 'admin' || activeJourney.type == 'business' && userRole == 'admin') || (activeJourney.type == 'global' && userRole == 'admin') || userRole == 'superadmin'"  ></div>
                {{ stage.name }}
                <div class="edit">
                  <v-btn icon class="mx-0" @click="editStage(stage)" v-if="(activeJourney.type == 'business' && userPermissions.journeyEditQuestions == true) || (userRole == 'admin' || activeJourney.type == 'business' && userRole == 'admin') || (activeJourney.type == 'global' && userRole == 'admin')  || userRole == 'superadmin'" >
                    <v-icon small color="white">edit</v-icon>
                  </v-btn>
                </div>
              </div>
              <div class="stage-desc-wrapper">
                  {{ stage.description }}
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <!-- / EDITABLE JOURNEY DATA \ -->
      <v-card class="my-4" outlined v-if="(activeJourney.type == 'business' && userPermissions.journeyEditQuestions == true) || (activeJourney.type == 'business' && userRole == 'admin')  || (activeJourney.type == 'business' && userRole == 'superadmin') || (activeJourney.type == 'global' && userRole == 'admin') || (activeJourney.type == 'global' && userRole == 'superadmin')">
        <div class="content-box-header clear">
          <div class="journey-heading-title">
            <h2>Vragen</h2>
            <p></p>
          </div>
          <div class="journey-heading-buttons" >
            <v-btn :color="companySecondaryColor" outlined v-if="stages.length > 0 && questions.length > 0 " @click.stop="newQuestionDialog = true">Vraag toevoegen</v-btn>
          </div>
        </div>

        <div class="no-content" v-if="stages.length == 0">
          <p><span><v-icon >info</v-icon></span> Voeg een stage toe om vragen toe te voegen</p>
        </div>

        <div class="no-content text-center" v-if="stages.length > 0 && questions.length == 0"> 
          <p>Nog geen vragen toegevoegd</p>
          <v-btn dark :color="companySecondaryColor" @click="newQuestionDialog = true">Vraag toevoegen</v-btn>
        </div>


        <v-data-table v-if="stages.length > 0 && questions.length > 0 "
          :headers="headersQuestions"
          :items="questions"
          :itemsPerPage.sync="questionsPages"
          hide-default-footer
          class="question-table"
          >
          <template v-slot:item="{item}">
            <tr>
              <td class="grap">
                <v-icon :color="$vuetify.theme.themes[theme].text">drag_indicator</v-icon>
              </td>
              <td>
                <span v-for="stage in stages" :key="stage.name">
                  <span class="questions-stage" v-if="item.stageId == stage.id" v-bind:style="{ background: stage.color } ">{{ stage.name }}</span>
                </span>
              </td>
              <td>  
                <span v-if="item.question.nl">{{ item.question.nl }}</span>
                <span v-else-if="item.question.en">{{ item.question.en }}</span>
              </td>
              <td style="text-transform: capitalize;">{{ item.type }}</td>
              <td>
                <div class="question-list-item active" v-bind:class="{  true: item.active }">
                  <div class="circle"></div>
                </div>
              </td>
              <td>
                <v-btn style="float: right;" icon class="mx-0" @click="editQuestion(item)">
                  <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <!-- \ EDITABLE JOURNEY DATA / -->

      <!-- / NON EDITABLE JOURNEY DATA \ -->
      <v-card class="my-4" outlined  v-if="(activeJourney.type == 'global' && (userRole != 'superadmin' && userRole != 'admin')) || (activeJourney.type == 'business' && userPermissions.journeyViewJourney == true)">
        <div class="content-box-header clear">
          <div class="journey-heading-title">
            <h2>Vragen</h2>
            <p></p>
          </div>
          <div class="journey-heading-buttons"></div>
        </div>

        <div class="no-content" v-if="stages.length == 0">
            <p><span><v-icon >info</v-icon></span> Voeg een stage toe om vragen toe te voegen</p>
          </div>

        <div class="no-content" v-if="stages.length > 0 && questions.length == 0"> 
          <p>Nog geen vragen toegevoegd</p>

          <v-btn :color="companySecondaryColor" outlined class="secondary-button active" @click.stop="newQuestionDialog = true">Vraag toevoegen</v-btn>
        </div>

        <v-data-table
          v-if="stages.length > 0 && questions.length > 0 "
          :headers="headersQuestionsNoEdit"
          :items="questions"
          :itemsPerPage.sync="questionsPages"
          hide-default-footer
          >
          <template v-slot:item="{item}">
            <tr>
              <td>
                <span v-for="stage in stages" :key="stage.name">
                  <span class="questions-stage" v-if="item.stageId == stage.id" v-bind:style="{ background: stage.color } ">{{ stage.name }}</span>
                </span>
              </td>
              <td>  
                <span v-if="item.question.nl">{{ item.question.nl }}</span>
                <span v-else-if="item.question.en">{{ item.question.en }}</span>
              </td>
              <td style="text-transform: capitalize;">{{ item.type }}</td>
              <td>
                <div class="question-list-item active" v-bind:class="{  true: item.active }">
                  <div class="circle"></div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <!-- \ NON EDITABLE JOURNEY DATA / -->

    </div>

    <!-- / New Journey Dialog \ -->
    <v-dialog v-model="newJourneyDialog" scrollable max-width="600px">
      <add-journey-form :showDialog="newJourneyDialog" :activeComp="activeCompData" :companies="companies"  @newJourneyDialogChange="newJourneyDialog = $event" @updateData="loadJourneys()"></add-journey-form>
    </v-dialog>
    <!-- \ New Journey Dialog / -->

     <!-- / Edit Journey Dialog \ -->
    <v-dialog v-model="editJourneyDialog"  scrollable max-width="600px">
      <edit-journey-form  :showDialog="editJourneyDialog" :activeComp="activeCompData" :companies="companies" :selectedJourney="selectedJourneyInfo" :selectedJourneyOriginal="selectedJourneyInfoOriginal" @editJourneyDialogChange="editJourneyDialog = $event" @updateData="loadJourneys()"></edit-journey-form>
    </v-dialog>
    <!-- \ Edit Journey Dialog / -->

    <!-- / New Stage Dialog \ -->
    <v-dialog v-model="newStageDialog" scrollable max-width="600px">
      <add-stage-form :showDialog="newStageDialog" :stages="stages" :exceptions="usedStageColors" :activeJourney="activeJourney" :activeComp="activeCompData"  @newStageDialogChange="newStageDialog = $event" @updateData="loadStages()"></add-stage-form>
    </v-dialog>
    <!-- \ New Stage Dialog / -->

    <!-- / Edit Stage Dialog \ -->
    <v-dialog v-model="editStageDialog" scrollable max-width="600px">
      <edit-stage-form  :selectedStage="selectedStageInfo"  :selectedStageOriginal="selectedStageInfoOriginal"  :activeComp="activeCompData"  :exceptions="usedStageColorsEdit" @editStageDialogChange="editStageDialog = $event" @updateData="loadStages()" @reloadQuestions="loadQuestions()"></edit-stage-form>
    </v-dialog>
    <!-- \ Edit Stage Dialog / -->

    <!-- / New Question Dialog \ -->
    <v-dialog v-model="newQuestionDialog" scrollable max-width="600px">
        <add-question-form :branches="branches" :activeJourney="activeJourney" :stages="stages" :questions="questions" :activeComp="activeCompData" :questionNextNumber="questionNextNumber"  @newQuestionDialogChange="newQuestionDialog = $event" @updateData="loadQuestions()"></add-question-form>
    </v-dialog>
    <!-- \ New Question Dialog / -->

    <!-- / Edit Question Dialog \ -->
    <v-dialog v-model="editQuestionDialog" scrollable max-width="600px">
        <edit-question-form :branches="branches" :activeJourney="activeJourney" :activeComp="activeCompData" :stages="stages" :selectedQuestion="selectedQuestionInfo" :selectedQuestionOriginal="selectedQuestionInfoOriginal"  @editQuestionDialogChange="editQuestionDialog = $event" @updateData="loadQuestions()"></edit-question-form>
    </v-dialog>
    <!-- \ Edit Question Dialog / -->
  </div>
</template>


<script>
import { bus } from "../main";
import firebase from "firebase/app";
import db from "../firebase/init";
import Sortable from "sortablejs";
import draggable from "vuedraggable";
import moment from "moment";

import AddJourneyForm from "../components/modals/AddJourneyForm.vue";
import AddStageForm from "../components/modals/AddStageForm.vue";
import AddQuestionForm from "../components/modals/AddQuestionForm.vue";

import EditJourneyForm from "../components/modals/EditJourneyForm.vue";
import EditStageForm from "../components/modals/EditStageForm.vue";
import EditQuestionForm from "../components/modals/EditQuestionForm.vue";
import { log } from "util";

export default {
  components: {
    "add-journey-form": AddJourneyForm,
    "add-stage-form": AddStageForm,
    "add-question-form": AddQuestionForm,
    "edit-journey-form": EditJourneyForm,
    "edit-stage-form": EditStageForm,
    "edit-question-form": EditQuestionForm
  },
  name: "customer-journey",
  data: () => ({
    showOverview: true,
    searchCompanies: "",
    search: "",
    newJourneyDialog: false,
    editJourneyDialog: false,
    newStageDialog: false,
    editStageDialog: false,
    editQuestionDialog: false,
    newQuestionDialog: false,
    selectedJourneyInfo: {},
    selectedJourneyInfoOriginal: {},
    selectedQuestionInfo: {
      question: {}
    },
    journeyPages: -1,
    selectedQuestionInfoOriginal: {},
    selectedStageInfo: {},
    selectedStageInfoOriginal: {},
    activeCompData: {},
    activeCompDataOriginal: {},
    activeComp: "",
    activeCompName: "",
    activeJourney: {},
    selectedJourney: {},
    activeCompJourneys: {},
    selectedCustomerJourney: [],
    selectedJourney: {},
    selected: [],
    branches: [],
    companies: [],
    questions: [],
    usedStageColors: [],
    usedStageColorsEdit: [],
    stages: [],
    journeys: [],
    questionsPages: -1,
    journeyTypes: [
      {
        name: "Algemeen",
        id: "global"
      },
      {
        name: "Individueel",
        id: "business"
      }
    ],
    questionNumbers: [],
    questionNumberMax: 0,
    stageNumbers: [],
    stageNextNumber: 0,
    questionNextNumber: 0,
    pagination: {
      sortBy: "order",
      rowsPerPage: "20"
    },
    headerJourneys: [
      {
        text: "Name",
        align: "left",
        value: "name",
        sortable: true
      },
      {
        text: "Omschrijving",
        align: "left",
        value: "description",
        sortable: false
      },
      {
        text: "Type",
        align: "left",
        value: "type",
        sortable: true
      },
      {
        text: "Actief",
        align: "left",
        value: "active",
        sortable: true
      },
      {
        text: "",
        align: "left",
        value: "",
        width: "60px"
      },
      {
        sortable: false,
        width: "60px"
      }
    ],

    headersQuestions: [
      {
        text: "",
        align: "center",
        value: "order",
        sortable: false,
        width: "50px"
      },
      {
        text: "Stage",
        align: "left",
        value: "stageId",
        sortable: false
      },
      {
        text: "Vraag",
        align: "left",
        value: "question",
        sortable: false
      },
      {
        text: "Type",
        align: "left",
        value: "type",
        sortable: false
      },
      {
        text: "Active",
        align: "center",
        value: "active",
        sortable: false
      },
      {
        value: "edit",
        sortable: false
      }
    ],
    headersQuestionsNoEdit: [
      {
        text: "Stage",
        align: "left",
        value: "stageId",
        sortable: false
      },
      {
        text: "Vraag",
        align: "left",
        value: "question",
        sortable: false
      },
      {
        text: "Type",
        align: "left",
        value: "type",
        sortable: false
      },
      {
        text: "Active",
        align: "center",
        value: "active",
        sortable: false
      }
    ],
    loading: true,
    journeyLoading: false
  }),

  created() {
    this.loadUserComp();
  },

  methods: {
    loadBranches() {
      db.collection("branches")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          this.branches = [];
          snap.forEach(doc => {
            let branchCollection = doc.data();
            branchCollection.id = doc.id;
            this.branches.push(branchCollection);
          });
        });
    },

    getJourneyComp() {
      bus.$emit("getActiveComp");
    },

    setRandomStageColor() {
      bus.$emit("setRandomStageColor");
    },

    backToOverview() {
      this.questions = [];
      this.stages = [];
      this.showOverview = true;
    },

    loadUserComp() {
      this.userDataLoaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.activeCompJourneys = this.companies[selectedCompanyIndex].journeys;
              this.activeCompName = this.companies[selectedCompanyIndex].name;
              this.loadJourneys();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.activeComp = this.companies[0].id;
              this.activeCompJourneys = this.companies[0].journeys;
              this.activeCompName = this.companies[0].name;
              this.loadJourneys();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadJourneys();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.activeCompJourneys = this.companies[0].journeys;
          this.activeCompName = this.companies[0].name;
          this.loadJourneys();
        }
      })
    },


    loadActiveCompData() {
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
        })
        .catch(error => {
          console.log("Error getting document:", error);
        });
    },

    // JOURNEY

    loadJourneys() {
      window.localStorage.setItem('selectedCompany', this.activeComp)
      this.loadActiveCompData();

      db.collection("journeys")
        .where(`companies.${this.activeComp}`, "==", true)
        .get()
        .then(snap => {
          this.journeys = [];
          snap.forEach(doc => {
            let journey = doc.data();
            this.stages = [];
            journey.id = doc.id;
            this.journeys.push(journey);
          });
        })
        .then(() => {
          this.showOverview = true;
          db.collection("companies")
            .doc(this.activeComp)
            .get()
            .then(doc => {
              this.activeCompJourneys = doc.data().journeys;
            })
            .then(() => {
              Object.filter = (obj, predicate) =>
                Object.keys(obj)
                  .filter(key => predicate(obj[key]))
                  .reduce((res, key) => ((res[key] = obj[key]), res), {});


              let filterActiveCompanies = Object.filter(this.activeCompJourneys, company => company == true);
              let journeyCompanies = _.keysIn(filterActiveCompanies);

              return journeyCompanies;
            })
            // .then(item => {
            //   this.activeCompJourneys = {};
            //   let journeys = this.journeys.forEach(journey => {
            //     if (journey.id == item) {
            //       this.activeCompJourneys[journey.id] = true;
            //       this.selectedJourney = journey.id;
            //     } else {
            //       this.activeCompJourneys[journey.id] = false;
            //     }
            //   });
            // });
        })
        .then(() => {
          this.loading = false;
        });
    },

    changeJourneyStatus(item, status) {

      console.log("check item: ", item, status)

      if(status == 'true'){
        this.activeCompJourneys[item] = false
        // let selectedJourney = item;
        // let selectedJourneyObject = {};
        // this.journeys.forEach(element => {
        //   if(element.id == item){
        //     selectedJourneyObject[element.id] = false;
        //   }
            
        // });

        // this.activeCompJourneys = selectedJourneyObject;

        console.log("activeCompJourneys: ", this.activeCompJourneys)

        db.collection("companies")
          .doc(this.activeComp)
          .update({
            journeys: this.activeCompJourneys
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                action: "Actieve Journey gewijzigd: " + this.activeCompName,
                extra: "<b>Journeys:</b> " + JSON.stringify(this.activeCompJourneys)
              })
              .catch(error => {
                console.error("Error logging new branch: ", error);
              });
          });
        

      }
      else if(status == 'false'){
        this.activeCompJourneys[item] = true
        // let selectedJourney = item;
        // let selectedJourneyObject = {};
        // this.journeys.forEach(element => {
        //   console.log("element: ", element)
        //   if (element.id == selectedJourney) {
        //     selectedJourneyObject[element.id] = true;
        //   }
        //   else {
        //     selectedJourneyObject[element.id] = selectedJourneyObject[element.id];
        //   }
        // });

        // this.activeCompJourneys = selectedJourneyObject;

        console.log("activeCompJourneys: ", this.activeCompJourneys)

        db.collection("companies")
          .doc(this.activeComp)
          .update({
            journeys: this.activeCompJourneys
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                action: "Actieve Journey gewijzigd: " + this.activeCompName,
                extra: "<b>Journeys:</b> " + JSON.stringify(this.activeCompJourneys)
              })
              .catch(error => {
                console.error("Error logging new branch: ", error);
              });
          });
      }
    },

    selectJourney(item) {
      this.showOverview = false;
      this.journeyLoading = true;
      this.activeJourney = item;
      db.collection("journeys")
        .doc(item.id)
        .get()
        .then(doc => {
          this.selectedJourney = [];
          let journey = doc.data();
          journey.id = doc.id;
          this.selectedJourney.push(journey);
          return journey.id;
        })
        .then(() => {
          this.loadStages();
        })
    },

    editJourney(item) {
      this.editJourneyDialog = true;
      this.editedIndex = this.journeys.indexOf(item);
      this.selectedJourneyInfo = Object.assign({}, item);
      this.selectedJourneyInfoOriginal = Object.assign({}, item);
      let delay = new Promise((resolve, reject) => {
        setTimeout(resolve, 300);
      });

      Promise.all([delay]).then(() => {
        bus.$emit("infoUpdate");
      });
    },

    // STAGES

    loadStages() {
      db.collection("stages")
        .where("journeyId", "==", this.activeJourney.id)
        .get()

        .then(snap => {
          this.stageNumbers = [];
          this.stages = [];
          snap.forEach(doc => {
            let stage = doc.data();
            stage.id = doc.id;
            this.stages.push(stage);
            this.stageNumbers.push(stage.order);
          });
        })
        .then(() => {
          this.stages.sort(this.sortStages);
          this.orderStages();
        })
        .then(() => {
          const stage = this.stages;
          stage.forEach(stage => {
            this.usedStageColors.push(stage.color);
          });
        })
        .then(()=>{
          // console.log("Stages geladen");
          this.loadQuestions();
        })
    },

    // De kleur van de geselecteerde vraag verwijderen uit de gebruikte kleuren

    sortStages(a, b) {
      // Use toUpperCase() to ignore character casing
      const genreA = a.order;
      const genreB = b.order;

      let comparison = 0;
      if (genreA > genreB) {
        comparison = 1;
      } else if (genreA < genreB) {
        comparison = -1;
      }
      return comparison;
    },

    orderStages() {
      let element = document.getElementById("stages");
      const vm = this;
      Sortable.create(element, {
        handle: ".handle",
        onEnd({ newIndex, oldIndex }) {
          const rowSelected = vm.stages.splice(oldIndex, 1)[0]; // Get the selected row and remove it
          vm.stages.splice(newIndex, 0, rowSelected); // Move it to the new index
          vm.updateOrderStages();
        }
      });
    },

    editStage(item) {
      this.editStageDialog = true;
      this.editedIndex = this.stages.indexOf(item);
      this.selectedStageInfo = Object.assign({}, item);
      this.selectedStageInfoOriginal = Object.assign({}, item);

      let exeptions = this.usedStageColors;
      this.usedStageColorsEdit = exeptions.filter(e => e !== item.color);
    },

    updateOrderStages(item) {
      let stages = this.stages;
      stages.forEach(item => {
        let numberItem = stages.indexOf(item);
        // console.log("Update Order: " + item.order + " wordt ArrayIndex: " + numberItem);
        db.collection("stages")
          .doc(item.id)
          .update({
            order: numberItem
          });
      });
    },

    // QUESTIONS

    loadQuestions() {
      db.collection("questions")
        // .where("compId", "==", this.activeComp)
        .where("journeyId", "==", this.activeJourney.id)
        .get()
        .then(snap => {
          this.questionNumbers = [];
          this.questions = [];
          snap.forEach(doc => {
            if (doc.data()) {
              let question = doc.data();
              question.id = doc.id;
              this.questions.push(question);
            }
          });
        })
        .then(() => {
          if (this.questions.length > 0) {
            this.questions.sort(this.sortQuestions);
            this.orderQuestions();
          }
          this.loadBranches();
        })
        .then(()=>{
          // console.log("questions geladen");
          this.journeyLoading = false;
        })
    },

    editQuestion(item) {
      this.editQuestionDialog = true;
      this.editedIndex = this.questions.indexOf(item);
      this.selectedQuestionInfo = Object.assign({}, item);
      this.selectedQuestionInfoOriginal = Object.assign({}, item);

      // Timeout om functie op te roepen die Array met Branches omzet naar Object als de Array is geladen.
      const delay = new Promise((resolve, reject) => {
        setTimeout(resolve, 300);
      });

      Promise.all([delay]).then(() => {
        if (this.activeJourney.type == "business") {
          bus.$emit("updateQuestionBranches");
        }
      });
    },

    deleteQuestion() {
      this.selected.forEach(element => {
        db.collection("questions")
          .doc(element.id)
          .delete()
          .then(() => {
            // console.log("Question successfully deleted!");
          })
          .catch(error => {
            console.error("Error removing question: ", error);
          });
      });
    },

    sortQuestions(a, b) {
      // Use toUpperCase() to ignore character casing
      const genreA = a.order;
      const genreB = b.order;

      let comparison = 0;
      if (genreA > genreB) {
        comparison = 1;
      } else if (genreA < genreB) {
        comparison = -1;
      }
      return comparison;
    },

    orderQuestions() {
      // console.log("Order questions");

      let element = document.querySelector(".question-table tbody");
      const vm = this;
      Sortable.create(element, {
        handle: ".grap",
        onEnd({ newIndex, oldIndex }) {
          const rowSelected = vm.questions.splice(oldIndex, 1)[0]; // Get the selected row and remove it
          vm.questions.splice(newIndex, 0, rowSelected); // Move it to the new index
          vm.updateOrderQuestions();
        }
      });
    },

    updateOrderQuestions(item) {
      console.log("Update Order");

      let questions = this.questions;
      questions.forEach(item => {
        let numberItem = questions.indexOf(item);
        // console.log("Update Question Order: " + item.order + " wordt ArrayIndex: " + numberItem);
        db.collection("questions")
          .doc(item.id)
          .update({
            order: numberItem
          });
      });
    }
  },

  computed: {
    reviewsPackage(){
      let packageStatus = { 
        type: 'inactive',
        days: 0
      }

      if(this.activeCompData.packages && this.activeCompData.packages.length > 0 && _.indexOf(this.activeCompData.packages, 'customerjourney') >= 0){
        packageStatus.type = 'active';
      }
      else{
        // Package not purchased, check for active trial
        if(this.activeCompData.trials && this.activeCompData.trials.length > 0){
          this.activeCompData.trials.forEach(trailPackage =>{
            if(trailPackage.id == 'customerjourney'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                packageStatus.type = 'trial';
                packageStatus.days = moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days').diff(moment(), 'days')
              }
            }
          })
        }
      }
      return packageStatus
    },

    bookingsList() {
      return this.questions.filter(question => {
        return questions.question.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
      });
    },

    dragOptions() {
      return {
        animation: 0,
        ghostClass: "ghost"
      };
    },

    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },

    demoMode(){
      return this.$store.state.demoMode;
    },
    
    userPermissions() {
      return this.$store.state.userPermissions;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    }
  }
};
</script>
